export default "__VITE_ASSET__BDHfYy69__"